export default __webpack_public_path__ + "static/media/creditCardGrey.cf486700.svg";